import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  standalone: true,
  styleUrls: ['unauthorized.component.scss'],
  templateUrl: 'unauthorized.component.html',
})
export class UnauthorizedComponent {

}
